<template>
    <div class="OJProblemManagement">
        <div class="clearfix top">
            <div class="fl" style="margin-right:10px">
                <el-form ref="form" :model="form" :inline="true" size="mini" @submit.native.prevent>
                    <el-form-item label="标题">
                        <el-input v-model="form.title" prefix-icon="el-icon-search" placeholder="请输入标题、题单编号" size="mini"
                            clearable @keyup.enter.native="search"></el-input>
                    </el-form-item>

                </el-form>
            </div>

            <div class="fl">
                <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>

                <el-button type="primary" @click="add" icon="el-icon-plus" size="mini">新增类型</el-button>
            </div>

        </div>
        <el-divider></el-divider>
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="sort_num" label="排序号">
            </el-table-column>

            <el-table-column prop="title" label="名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="edit(scope.row)" size="mini">编辑</el-button>
                    <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clearfix" style="margin-top: 20px;">

            <div class="fr" style=" text-align: right">
                <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
                    layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 添加 -->
        <el-dialog title="新增类型" z-index="1000" :visible.sync="dialogVisible" width="80%">
            <el-form ref="addForm" :model="addForm" label-width="80px">
                <el-form-item label="排序号" prop="sort_num">
                    <el-input-number v-model="addForm.sort_num" :precision="1" :step="0.1"></el-input-number>
                </el-form-item>

                <el-form-item label="类型名称" prop="title">
                    <el-input v-model="addForm.title" placeholder="请输入类型名称"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close('addForm')">取 消</el-button>
                <el-button type="primary" @click="submit('addForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>

import {
    adminAddOrUpdateOjProblemListType,
    adminGetOjProblemListTypeList,
    adminDeleteOjProblemListType,

}
    from "@/api/adminOj.js";
export default {

    data() {
        return {
            difficultyId: '',
            addForm: {
                sort_num: 0,
                title: '',
            },
            form: {

            },
            dialogVisible: false,
            page_no: 1,
            page_size: 20,
            total: 20,
            keyword: '',
            tableData: [

            ],


        }
    },
    mounted() {
        this.adminGetOjProblemListTypeList()
    },
    methods: {
        //删除
        del(row) {
            this.$confirm('是否确认删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                adminDeleteOjProblemListType({
                    id: row.id,
                    ifIgnore: 0
                }).then((res) => {

                    if (res.is_delete === true) {
                        this.$message.success("删除成功");
                        this.adminGetOjProblemListTypeList()
                    } else {
                        this.$confirm('已有题单使用了该来源，是否强制删除', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            adminDeleteOjProblemListType({
                                id: row.id,
                                ifIgnore: 1
                            }).then(() => {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.adminGetOjProblemListTypeList()
                            })

                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消删除'
                            });
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        search() {
            this.page_no = 1
            this.adminGetOjProblemListTypeList()
        },
        adminGetOjProblemListTypeList() {
            adminGetOjProblemListTypeList({
                ...this.form,
                page_no: this.page_no,
                page_size: this.page_size
            }).then((res) => {
                console.log(res)
                this.tableData = res.ojProblemListTypeList
                this.total = res.total
            })
        },
        //关闭
        close() {
            // this.$refs["addForm"].resetFields();
            this.dialogVisible = false
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.difficultyId) {
                        console.log(123, 45)
                        adminAddOrUpdateOjProblemListType({
                            id: this.difficultyId,
                            ...this.addForm
                        }).then(() => {
                            this.$message.success('修改成功!')
                            this.close()
                            this.adminGetOjProblemListTypeList()

                        })
                    } else {
                        adminAddOrUpdateOjProblemListType({
                            ...this.addForm
                        }).then(() => {
                            this.$message.success('添加成功!')
                            this.close()
                            this.adminGetOjProblemListTypeList()

                        })
                    }
                }
            });
        },
        handleCurrent(val) {
            this.page_no = val
            this.adminGetOjProblemListTypeList()

        },
        add() {
            this.difficultyId = ''
            this.addForm.sort_num = 0
            this.addForm.title = null
            this.dialogVisible = true
        },
        edit(row) {
            this.difficultyId = row.id
            this.addForm.sort_num = row.sort_num
            this.addForm.title = row.title
            this.dialogVisible = true

        },


    }

}
</script>
<style lang="scss" scoped>
.OJProblemManagement {
    margin: 10px;
    padding: 20px;

    background: white;
    border-radius: 5px;
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.clearfix:after {
    content: "";
    display: block;
    visibility: hidden;
    clear: both;
}

.top {
    font-size: 18px;
    font-weight: 300;
}

/deep/ .el-radio-group {
    margin-top: 7px;
}

/deep/ .el-divider--horizontal {
    margin-top: 0px;
}
</style>